import { format } from 'date-fns';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Calendar, FileText } from 'lucide-react';

interface ReviewStepProps {
    expiresAt: string;
    certificateFile: File | null;
    existingCertificateUrl: string | null;
    isEditing: boolean;
}

export default function ReviewStep({
    expiresAt,
    certificateFile,
    existingCertificateUrl,
    isEditing,
}: ReviewStepProps) {
    return (
        <div className="space-y-6">
            <div className="flex items-center gap-2 text-emerald-600">
                <CheckCircle2 className="h-5 w-5" />
                <span className="font-medium">
                    {isEditing ? 'Review Changes' : 'Ready to Save'}
                </span>
            </div>

            <div className="space-y-4">
                {/* Certificate Details */}
                <Card>
                    <CardContent className="pt-4">
                        <div className="flex items-center gap-2 mb-3 text-sm font-medium text-muted-foreground">
                            <Calendar className="h-4 w-4" />
                            Certificate Details
                        </div>
                        <div className="space-y-2">
                            <div className="flex justify-between">
                                <span className="text-sm text-muted-foreground">Expires</span>
                                <span className="text-sm font-medium">
                                    {expiresAt ? format(new Date(expiresAt), 'MMM d, yyyy') : '-'}
                                </span>
                            </div>
                            <div className="flex justify-between items-center">
                                <span className="text-sm text-muted-foreground">Document</span>
                                {certificateFile ? (
                                    <Badge variant="secondary" className="text-xs">
                                        <FileText className="h-3 w-3 mr-1" />
                                        {certificateFile.name}
                                    </Badge>
                                ) : existingCertificateUrl ? (
                                    <Badge variant="outline" className="text-xs">
                                        Existing document
                                    </Badge>
                                ) : (
                                    <span className="text-sm text-muted-foreground">No document</span>
                                )}
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
